module.exports = __webpack_public_path__ + "static/media/cq_prima_del_finanziamento b.463b36db.svg";